import { useState } from "react";
import Seo from "@/components/Seo";
import ProductCard from "@/components/ProductCard";
import { EnquiryDialog } from "@/components/forms";
import { Reveal, Eyebrow } from "@/components/motion";
import { useSite } from "@/context/SiteContext";

const FILTERS = ["All", "Maize", "Wheat"];

export default function Products() {
  const { products, loading } = useSite();
  const [filter, setFilter] = useState("All");
  const visible = filter === "All" ? products : products.filter((p) => p.crop === filter);

  return (
    <>
      <Seo
        title="Seed Portfolio — Maize & Wheat Seeds | ICROPSIA India"
        description="Explore the ICROPSIA seed portfolio: Sipra 6655 and Sipra 8165 maize seeds and Siya 303 wheat seed, supplied in 25 kg branded bags across Bihar."
      />
      <section className="pt-40 pb-16 bg-brand-ink relative overflow-hidden">
        <div className="absolute inset-0 grain opacity-20" />
        <div className="container-site relative">
          <Reveal>
            <Eyebrow light>Product Catalog</Eyebrow>
            <h1 className="mt-4 font-display text-4xl sm:text-5xl font-extrabold tracking-tight text-white leading-[1.05]">
              Explore the ICROPSIA <span className="font-editorial italic font-semibold text-brand-wheat">Seed Portfolio</span>
            </h1>
            <p className="mt-5 max-w-2xl text-white/70 leading-relaxed">
              Discover our maize and wheat seed varieties and explore the product information available for each variety.
            </p>
          </Reveal>
        </div>
      </section>

      <section className="py-16 sm:py-20">
        <div className="container-site">
          <div className="flex gap-2 mb-10" role="tablist" aria-label="Filter by crop">
            {FILTERS.map((f) => (
              <button
                key={f}
                role="tab"
                aria-selected={filter === f}
                data-testid={`filter-${f.toLowerCase()}`}
                onClick={() => setFilter(f)}
                className={`rounded-full px-5 py-2.5 text-sm font-bold transition-all ${
                  filter === f ? "bg-brand-deep text-white shadow-lg shadow-brand-deep/20" : "bg-white text-brand-deep/60 border border-brand-deep/15 hover:border-brand-deep/40"
                }`}
              >
                {f}
              </button>
            ))}
          </div>

          {loading ? (
            <p className="text-brand-charcoal/50 text-sm">Loading products…</p>
          ) : (
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-7 lg:gap-9">
              {visible.map((p, i) => (
                <div key={p.slug} className="flex flex-col">
                  <ProductCard product={p} index={i} />
                  <EnquiryDialog
                    productName={p.name}
                    triggerTestid={`products-enquire-${p.slug}`}
                    triggerClassName="mt-3 rounded-full border-2 border-brand-deep px-5 py-2.5 text-sm font-bold text-brand-deep transition-all hover:bg-brand-deep hover:text-white"
                  />
                </div>
              ))}
            </div>
          )}
        </div>
      </section>
    </>
  );
}
